export default "__VITE_ASSET__va8uLEy1__"